import { gql } from "@apollo/client";

// Mutations
export const ADD_FINICITY_ACCOUNTS = gql`
  mutation UpdateFinicityPaymentMethods {
    addFinicityAccounts {
      status
      message
    }
  }
`;

export const REMOVE_ACCOUNT = gql`
  mutation RemoveAccount($id: ID) {
    removeAccount(id: $id) {
      status
      message
    }
  }
`;

export const ADD_PLAID_ACCOUNTS = gql`
  mutation addPlaidAccounts(
    $publicToken: String!
    $institution: PlaidAddedInstitution!
  ) {
    addPlaidAccounts(publicToken: $publicToken, institution: $institution) {
      status
      message
    }
  }
`;

export const UPDATE_LINK_BANK_STEP = gql`
  mutation updateBankStep {
    updateLinkBankStep {
      status
      message
    }
  }
`;